import axios from "axios";
import dotenv from "dotenv";
dotenv.config();

let apiUrl;
if (process.env.NODE_ENV === "production") {
  apiUrl = `${process.env.REACT_APP_SITE_URL}`;
} else {
  apiUrl = `${process.env.REACT_APP_BASE_URL}:${process.env.REACT_APP_PORT}`;
}
export const verifyUploadAPI = {
  importFile: async (fileContent, annotations, fileName, type) => {
    //axios.post(`${config.baseUrl}${config.importFile}${config.importFileCode}`, fileContent, {
    try {
      const res = await axios.post(
        `${apiUrl}${process.env.REACT_APP_UPLOAD_MATCHING_FILE_ENDPOINT}${process.env.REACT_APP_UPLOAD_MATCHING_FILE_CODE}`,
        fileContent,
        {
          headers: {
            "Content-Type": "text/plain",
          },
          params: {
            annotations: annotations,
            fileName: fileName,
            insertDate: new Date(),
            type: type,
          },
          timeout: 60000,
        }
      );
      return res;
    } catch (error) {
      if (error.response.status === "401") {
        window.sessionStorage.removeItem("user");
        window.sessionStorage.clear();
        //window.location.href = '/Unauthorized';
        window.location.href = "/unauthorized";
      }
      if (
        error.response &&
        error.response.data &&
        error.response.data.length > 0
      ) {
        return error.response.data;
      }
      console.log(error);
    }
  },
  exportExcel: (downloadId, type) => {
    try {
      return axios.get(
        `${apiUrl}${process.env.REACT_APP_EXPORT_COMPARE_ENDPOINT}${process.env.REACT_APP_EXPORT_COMPARE_CODE}`,
        {
          headers: { "Content-Type": "application/json" },
          params: {
            downloadId: downloadId,
            type: type,
          },
          responseType: "blob",
        }
      );
    } catch (error) {
      if (error.response.status === "401") {
        window.sessionStorage.removeItem("user");
        window.sessionStorage.clear();
        //window.location.href = '/Unauthorized';
        window.location.href = "/unauthorized";
      }
      if (
        error.response &&
        error.response.data &&
        error.response.data.length > 0
      ) {
        return error.response.data;
      }
      console.log(error);
    }
  },
};
